export const showFdicBanner = () => {
  if (global.BROWSER) {
    // TODO: iterate through FDIC banner list and check if the current locale is in the list
    return window.location.pathname.toLowerCase().includes('en-us');
  }
  return false;
};
